/**
 * Created by xyy2017 on 2017/9/25.
 */
import http from './http.js'

const req = (path) => {
	var vals = path.split(' ');
	return (params) => {
		return new Promise((resolve, reject) => {
			http[vals[0]](vals[1], params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			});
		});
	}
}
const bomtApi = { // 智能营销的接口
	getSeries: function () {
		return new Promise((resolve, reject) => {
			http.bomtPost('/carModel/queryAll', {level: 1}).then(response => {
				const data = (response.data.data || []).filter(item => {
					return item.status.name === 'Y'
				})
				response.data.data = data.map(item => {
					return {
						...item,
						seriesCode: item.carCode,
						seriesName: item.name
					}
				})
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getProvince: function () {
		return new Promise((resolve, reject) => {
			http.bomtPost('/area/query', {parentRegionId: 10045}).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getCity: function ({provinceId, provId}) {
		return new Promise((resolve, reject) => {
			http.bomtPost('/area/query', {parentRegionId: provinceId || provId}).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	getDealer: function ({province, city, seriesCode: carType}) { // 获取经销商
		return new Promise((resolve, reject) => {
			http.bomtPost('/dealerConfig/queryByArea', { province,city, carType }).then(response => {
				const data = response.data.data || []
				response.data.data = data.map(item => {
					return {
						dealerId: item.dealerCode,
						address: '--',
						...item // 如果返回的经销商信息有dealerId和address那么就用返回的信息
					}
				})
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	}
}
export default {
	//注册
	register: {
		step1: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/member/registerStep1', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		step2: function (params) {
			return new Promise((resolve, reject) => {
				http.postJson('/mapi/member/registerStep2', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		step3: function (params) {
			return new Promise((resolve, reject) => {
				http.post('/mapi/member/registerStep3', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		step4: function (params) {
			return new Promise((resolve, reject) => {
				http.postPic('/mapi/member/registerStep4', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		step5: function (params) {
			return new Promise((resolve, reject) => {
				http.postJson('/mapi/member/registerStep5', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		confirm: function (params) {
			return new Promise((resolve, reject) => {
				http.post('/mapi/member/confirm', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getRegisterProtocol: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/api/register/getRegisterProtocol', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getProvinceData: function () {
			return new Promise((resolve, reject) => {
				http.get('/mapi/region/listProvince').then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getCityData: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/region/listCity/' + params.provinceId).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getDistrictData: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/region/listDistrict/' + params.cityId).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getMemberProfile: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/member/getMemberProfile', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		}
	},
	//绑定手机号1
	bindPhone: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/login/bindPhone', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//绑定手机号2
	bindLogin: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/thirdlogin/bindLogin', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//发送手机验证码
	sendSmsCode: function (params) {
		return new Promise((resolve, reject) => {
			http.get('/mapi/member/sendSmsCode', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//发送手机验证码
	sendSmsCodeForAuthLogin: function (params) {
		return new Promise((resolve, reject) => {
			http.get('/mapi/member/sendSmsCodeForAuthLogin', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//注册登录接口
	loginRegisterByPhone: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/member/loginRegisterByPhone', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	sendForgetPwdSmsCode: function (params) {
		return new Promise((resolve, reject) => {
			http.get('/mapi/member/sendForgetPwdSmsCode', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//获取事业部信息
	getBusinessDepartment: function (params,config = {}) {
		return new Promise((resolve, reject) => {
			http.get('/mapi/getBusinessDepartment', params,config).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//验证忘记密码手机验证码
	validateSmsCode: function (params) {
		return new Promise((resolve, reject) => {
			http.get('/mapi/member/validateSmsCode', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//获取验证码
	getChkCode: function (params) {
		return new Promise((resolve, reject) => {
			http.get('/mapi/member/getChkCode', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//登录
	login: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/member/login', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//登出
	logout: function (params) {
		return new Promise((resolve, reject) => {
			http.get('/mapi/member/logout', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//忘记密码
	resetPassword: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/member/resetPassword', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//第三登录(获取登录授权链接)
	getAuthUrl: function (params) {
		return new Promise((resolve, reject) => {
			http.get('/mapi/thirdlogin/getAuthUrl', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 预约试驾接口
	drivePredict: function (params) {
		return new Promise((resolve, reject) => {
			http.post('http://intf-dev.geely.com/contactInfo', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	home: {},
	personalCenter: {
		listOrder: function (params) {
			//我的订单
			return new Promise((resolve, reject) => {
				http.get('/mapi/order/listOrder', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		listMyOrders: function (params) {
			//查看所有订单
			return new Promise((resolve, reject) => {
				http.get('/mapi/order/listOrderList', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		orderDetail: function (params) {
			//订单详情
			return new Promise((resolve, reject) => {
				http.get('/mapi/order/detail/' + params.orderId, params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		listMyBooks: req("get http://intf-dev.geely.com/contactInfo/queryRecords"),
		//获取个人基本资料
		getUserProfile: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/api/member/getUserProfile', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//获取用户信息侧边栏
		getUserInfoSilder: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/member/getMemberInfo', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//签到接口
		Dosign: function (params) {
			return new Promise((resolve, reject) => {
				http.post('/api/sign', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//获取推荐标签
		getRecommendTag: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/api/getRecommendTag', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//更新个人资料
		updateProfile: function (params) {
			return new Promise((resolve, reject) => {
				http.postJson('/api/member/updateProfile', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//修改手机号
		updatePhone: function (params) {
			return new Promise((resolve, reject) => {
				http.post('/api/member/updatePhone', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//发送本人手机号验证码
		sendSelfPhoneCode: function (params) {
			return new Promise((resolve, reject) => {
				http.post('/api/member/sendSelfPhoneCode', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//验证手机号是否是本人
		verifyPhone: function (params) {
			return new Promise((resolve, reject) => {
				http.post('/api/member/verifyPhone', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//上传头像
		setHeadImg: function (params) {
			return new Promise((resolve, reject) => {
				http.postPic('/api/member/setHeadImg', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//获取用户等级和等级特权
		getMemberLevel: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/api/member/getMemberLevel', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//获取个人第三方绑定账号
		getThirdAccount: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/api/member/getThirdAccount', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		//获取预约试驾信息列表
		getPredictList: function (params) {
			return new Promise((resolve, reject) => {
				http.postJson('/mapi/member/getPredictInfo', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		}
	},
	product: {
		getSkuByProductId: function (params) {
			return new Promise((resolve, reject) => {
				http.get(`/mapi/product/getSkuByProductId?productId=${params.productId}`).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getProductTypeDictAttrValue: function (params) {
			return new Promise((resolve, reject) => {
				http.get(`/mapi/productTypeDict/listByProductTypeAttrValue?productTypeAttrId=${params.productTypeAttrId}`).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getProductTypeDictSpecValue: function (params) {
			return new Promise((resolve, reject) => {
				http.get(`/mapi/productTypeDict/listByProductTypeSpecValue?specId=${params.specId}`).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getProductType: function (params) {
			return new Promise((resolve, reject) => {
				http.get(`/mapi/productTypeDict/listByPage`, params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getProductInfo: function (params) {
			return new Promise((resolve, reject) => {
				http.get(`/mapi/product/getProductMessage?productId=${params.productId}`).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		fetchDataList(params) {
			return new Promise((resolve, reject) => {
				http.postJson('/mapi/product/listCarOverview', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		listAllCarInfo: req("get /mapi/predict/listAllCarInfo")
	},
	order: {
		saveOrder: function (params) {
			return new Promise((resolve, reject) => {
				http.postJson('/mapi/order/saveOrder', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		payOrderByAlipay: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/order/alipay', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		payOrderByWechat: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/order/wechatPay', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getProvList: bomtApi.getProvince, // 获取省信息改为调用智能营销系统 预约试驾
		/*getCityList: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/region/listCity/' + params.provId).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},*/
		getCityList: bomtApi.getCity, // 获取市信息改为调用智能营销系统 预约试驾
		getDealerList: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/region/dealerList', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		// getDealerList: bomtApi.getDealer, // 获取经销商信息改为调用智能营销系统 预约试驾
		getMyOrderDetail: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/order/detail/' + params.orderId, params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		cancelOrder: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/order/cancel', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		applyForRefund: function (params) {
			return new Promise((resolve, reject) => {
				http.get('/mapi/order/applyForRefund', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		}
	},
	index: {
		searchEnable: function () {
			return new Promise((resolve, reject) => {
				http.get('/mapi/template/searchEnable').then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		getProductInfo: function (params) {
			return new Promise((resolve, reject) => {
				http.postJson('/mapi/product/getIndexProductMessage', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
	},
	//腾讯用户中心  发送手机验证码
	sendSmsCodeTx: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/tXUserCenter/sendSmsCode', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//腾讯用户中心  再次发送手机验证码
	resendSmsCodeTx: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/tXUserCenter/resendSmsCode', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//腾讯用户中心  手机验证码登录
	loginByPhoneMsgTx: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/tXUserCenter/loginByPhoneMsg', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//腾讯用户中心  手机密码登录
	loginByPhonepwdTx: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/tXUserCenter/loginByPhonepwd', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//腾讯用户中心  手机号登录注册接口，返回token
	loginRegisterByPhoneTx: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/tXUserCenter/loginRegisterByPhone', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//腾讯用户中心  手机号注册
	registerStepTx: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/tXUserCenter/registerStep', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//腾讯用户中心  手机号验证码重置密码
	resetPasswordTx: function (params) {
		return new Promise((resolve, reject) => {
			http.post('/mapi/tXUserCenter/resetPassword', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//腾讯用户中心  查询用户信息
	getMemberInfoTx: function (params) {
		return new Promise((resolve, reject) => {
			http.get('/mapi/tXUserCenter/getMemberInfo', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//腾讯用户中心  更新用户信息
	updateMemberProfileTx: function (params) {
		return new Promise((resolve, reject) => {
			http.postJson('/mapi/tXUserCenter/updateMemberProfile', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//更新头像
	uploadFileImage: function (params) {
		return new Promise((resolve, reject) => {
			http.postPic('/mapi/order/activityHandedOut/uploadFileImage2', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	//获取省市区
	getRegionArea: function (params) {
		return new Promise((resolve, reject) => {
			http.get('/mapi/region/area', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 收藏
	modifyFavorite: req("postJson /mapi/memberFavorite/modifyMemberFavorite"),
	// 收藏列表
	listMemberFavoriteByPage: req('postJson /mapi/memberFavorite/listMemberFavoriteByPage'),
	// 收藏批量取消
	batchCancelMemberFavorite: req('post /mapi/memberFavorite/batchCancelMemberFavorite'),
	purchaseBudget: {
		getBudget: req("get /mapi/purchaseBudget/getBudget"),
		getCarNameByProductId: req('get /mapi/purchaseBudget/getCarNameByProductId'),
		getBudgetPeriod: req('get /mapi/purchaseBudget/getBudgetPeriod')
	},
	getMemberInfoByPhone: req("get /mapi/member/getMemberInfoByPhone"),
	isMobileRegistered: req('get mapi/member/isMobileRegistered'),
	memberPredict: req('get /mapi/member/memberPredict'),
	integration: {
		// getSeriesInfo: req("get /mapi/integration/series"),
		getSeriesInfo: bomtApi.getSeries  // 获取车系信息改为调用智能营销系统 预约试驾
	},
	getClubUserInfo: req('get /mapi/member/getClubUserInfo'),
	getMsgByPhone: req('get /mapi/member/getMsgByPhone'),
	listRefundReasonByCode: req('get /mapi/order/listRefundReasonByCode'),
	unbindLogin: req('post /mapi/thirdlogin/unbindLogin'),
	// 足迹
	modifyMemberHistory: req('postJson /mapi/memberHistory/modifyMemberHistory'),
	// 足迹列表
	listMemberHistory: req('postJson /mapi/memberHistory/listMemberHistory'),
	// 活动商品详情
	getActivityProductMessage: req('get /mapi/product/getActivityProductMessage'),
	// 获取活动商品
	activitySaveOrder: req('postJson /mapi/order/activity/saveOrder'),
	// 整车使用获取抢鲜码
	getActivityCode: req('get /mapi/product/getActivityCode'),
	// 是否活动车型
	getActivityCodeByCarId: req('get /mapi/product/getActivityCodeByCarId'),
	// 抢鲜码详情
	getMyActivityCode: req('post /mapi/product/getMyActivityCode'),
	// 获取分享数据
	getCountByOrderId: req('get /mapi/order/getCountByOrderId'),
	// 获取微信分享二维码
	getUrlQRCode: req('get /mapi/order/getUrlQRCode'),
	// 收藏置顶
	showTopMemberFavorite: req('get /mapi/memberFavorite/showTopMemberFavorite'),
	// 取消收藏置顶
	unShowTopMemberFavorite: req('get /mapi/memberFavorite/unShowTopMemberFavorite'),
	// 删除足迹
	batchCancelMemberHistory: req('post /mapi/memberHistory/batchCancelMemberHistory'),
	// 是否收藏
	selectMemberFavoriteByProductId: req('get /mapi/memberFavorite/selectMemberFavoriteByProductId'),
	// 订单优惠信息
	getOrderActivityCode: req('get /mapi/product/getOrderActivityCode'),
	// 获取服务器时间
	getServerTime: req('get /mapi/order/getServerTime'),
	// 未登录情况，好看商品用户评论列表
	listCommentByPage: req('postJson /mapi/comment/listCommentByPage'),
	// 未登录情况，经销商评价列表
	listDealerCommentByPage: req('postJson /mapi/comment/listDealerCommentByPage'),
	// 未登录情况，平均分
	getCommentAvgScore: req('postJson /mapi/comment/getCommentAvgScore'),
	// 登录情况，需评价的商品订单列表
	listOrderProductCommentByPage: req('postJson /mapi/comment/listOrderProductCommentByPage'),
	// 登录情况，获取评论详情
	getOrderComment: req('get /mapi/comment/getOrderComment'),
	// 登录情况，评论页面初始化信息
	indexOrderComment: req('get /mapi/comment/indexOrderComment'),
	// 保存评价
	saveOrderComment: req('postJson /mapi/comment/saveOrderComment'),
	// 登录情况，经销商和商品评论保存
	preservationIndexOrderComment: req('post /mapi/comment/indexOrderComment'),
	// 登录情况，上传图片
	uploadFileImge: req('post /mapi/comment/uploadFileImge'),
	// 经销商列表增加产品id
	dealerInfoList: req('get /mapi/region/dealerInfoList'),
	// dealerInfoList: bomtApi.getDealer, // 获取经销商信息改为调用智能营销系统 下单
	// 图片验证码
	getKaptchaCode: req('get /mapi/common/getKaptchaCode'),
	// 追加评价
	initappend: req('get /mapi/comment/initappend'),
	// 保存追加评价
	saveappend: req('postJson /mapi/comment/saveappend'),
	// 获取评论头像
	getUserImg: req('get /mapi/comment/getUserImg'),
	// 二次授权省列表
	// province: req('get /mapi/region/province'),
	province: bomtApi.getProvince, // 获取省信息改为调用智能营销系统 下单
	// 二次授权市列表
	// city: req('get /mapi/region/city'),
	city: bomtApi.getCity, // 获取市信息改为调用智能营销系统 下单
	// 购物车
	preorder: {
		// 购物车详情
		detail: req('get /mapi/preorder/detail'),
		// 购物车列表
		search: req('postJson /mapi/preorder/search'),
		// 保存到购物车
		save: req('postJson /mapi/preorder/save'),
		// 购物车保存订单
		saveOrder: req('postJson /mapi/preorder/saveOrder'),
		// 删除购物车
		delete: req('get /mapi/preorder/delete'),
		// 修改购物车
		update: req('post /mapi/preorder/update')
	},
	//隐私政策
	policy: {
		queryAgreeCookie: function (params) {
			return new Promise((resolve, reject) => {
				http.post('/mapi/memberSecurity/queryAgreeCookie', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		saveAgreeCookie: function (params) {
			return new Promise((resolve, reject) => {
				http.post('/mapi/memberSecurity/saveAgreeCookie', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		deleteAgreeCookie: function (params) {
			return new Promise((resolve, reject) => {
				http.post('/mapi/memberSecurity/deleteAgreeCookie', params).then(response => {
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		}
	}

}



// WEBPACK FOOTER //
// ./src/util/api.js